// extracted by mini-css-extract-plugin
var _1 = "hoNouCRR0_";
var _2 = "rKHytsze6q";
var _3 = "oqpW0wVDci";
export { _1 as "localeLink", _2 as "localeList", _3 as "root" }
